import { api } from '@/shared/api/axios';

export interface Project {
  id: string;
  name: string;
  status: string;
}

export interface ProjectsResponse {
  projects: Project[];
}

export const fetchActiveProjects = async (): Promise<ProjectsResponse> => {
  const { data } = await api.get<ProjectsResponse>('/api/projects');
  return data;
};
